import React from "react";
import PropTypes from "prop-types";
import { CalendarCheck01, File04, Users01 } from "@opendate-app/setlist";
import SectionNavigation from "../shared/components/SectionNavigation/SectionNavigation";

const ICONS = {
  classes: CalendarCheck01,
  templates: File04,
  instructors: Users01,
};

function ClassesSectionNavigationApp({ title, activeKey, searchUrl, items }) {
  return (
    <SectionNavigation
      title={title}
      activeKey={activeKey}
      searchUrl={searchUrl}
      items={items.map((item) => ({ ...item, icon: ICONS[item.key] }))}
    />
  );
}

ClassesSectionNavigationApp.propTypes = {
  title: PropTypes.string.isRequired,
  activeKey: PropTypes.string,
  searchUrl: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      count: PropTypes.number,
    })
  ).isRequired,
};

export default ClassesSectionNavigationApp;
